document.addEventListener("DOMContentLoaded", () => {
    const elements = {
        blogSlider: document.querySelector('.blog-list'),
        blogCards: document.querySelectorAll('.blog-card'),
        blogSearch: document.querySelectorAll('#blogSearchForm')
    }



    function handleSearch(searchString) {
        // Remove the current blog cards
        elements.blogCards.forEach(card => card.remove());
        // Add the loading spinner
        let loadingDiv = document.createElement("div");
        loadingDiv.classList.add("se-loading");
        elements.blogSlider.appendChild(loadingDiv);
        // Send the query
        jQuery.ajax({
            type: "post",
            url: tntAjax.ajaxurl,
            data: {
                "action" : "blog_search",
                "searchterm" : searchString,
            },
            success: function (response) {
                // Remove the loading spinner
                document.querySelector(".se-loading").remove();
                // add the results
                elements.blogSlider.innerHTML = response;
                document.querySelector("#searchsubmit").disabled = false;
            },
            error: function (response) {
                // Remove the loading spinner
                document.querySelector(".se-loading").remove();
                console.error(response);
            }
        })

    }

    if(elements.blogCards && elements.blogSlider) {
        document.addEventListener("submit", (e) => {

            if (e.target && e.target.matches('#blogSearchForm')) {
                e.preventDefault();

                const blogSearchSubmitBtn = e.target.querySelector("#searchsubmit");
                if (blogSearchSubmitBtn) blogSearchSubmitBtn.disabled = true;

                const searchBox = e.target.querySelector("#blogSearchTerm");

                if (searchBox) {
                    const searchTerm = searchBox.value ?? "";
                    handleSearch(searchTerm);
                } else {
                    console.error("Something went wrong when getting the value");
                }
            }
        });

    }
});